export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_120_ACCEPT': 'Accept',
    '_694_ADD_A_PHOTO': 'Add a Photo',
    '_707_ANSWER': 'Answer',
    '_839_ANSWER_MUST_BE_A_MINIMUM_OF__REQUIREDLENGTH__CHARACTERS_': 'Answer must be a minimum of {{requiredLength}} characters.',
    '_121_CANCEL': 'Cancel',
    '_111_CHANGE_PASSWORD': 'Change Password',
    '_695_CHANGE_PHOTO': 'Change Photo',
    '_122_CHANGE_PROFILE_PICTURE': 'Change Profile Picture',
    '_112_CHANGE_SECURITY_QUESTION': 'Change Security Question',
    '_763_CLOSE': 'Close',
    '_814_COMPAS_WAS_UNABLE_TO_CHANGE_YOUR_SECURITY_QUESTION_AND_ANSWER__PLEASE_TRY_AGAIN_': 'Compas was unable to change your security question and answer. Please try again.',
    '_693_CONFIRM_NEW_PASSWORD': 'Confirm New Password',
    '_113_CURRENT_EMPLOYEE_TYPE': 'Current Employee Type',
    '_114_CURRENT_ROLE': 'Current Role',
    '_115_CURRENT_SUPERGROUP': 'Current SuperGroup',
    '_38_EMAIL': 'Email',
    '_73_END_DATE': 'End Date',
    '_77_HIERARCHY_TYPE': 'Hierarchy Type',
    '_44_HIRE_DATE': 'Hire Date',
    '_45_LANGUAGE': 'Language',
    '_48_MANAGER': 'Manager',
    '_116_MY_COMPAS_PROFILE': 'My Compas Profile',
    '_53_NAME': 'Name',
    '_692_NEW_PASSWORD': 'New Password',
    '_80_NO_SECURITY_GROUPS_CONFIGURED': 'No Security Groups Configured',
    '_82_NO_SUPERGROUPS_CONFIGURED': 'No SuperGroups Configured',
    '_83_NO_SYSTEM_ACCESSES_CONFIGURED': 'No System Accesses Configured',
    '_78_NO__LABEL_S_CONFIGURED': 'No {{label}}s Configured',
    '_637_OKAY': 'Okay',
    '_691_OLD_PASSWORD': 'Old Password',
    '_808_PASSWORD_CHANGE_FAILED_': 'Password change failed!',
    '_810_PASSWORD_CHANGE_SUCCESSFUL_': 'Password change successful!',
    '_837_PASSWORD_MUST_BE_A_MINIMUM_OF__REQUIREDLENGTH__CHARACTERS_': 'Password must be a minimum of {{requiredLength}} characters.',
    '_653_PASSWORDS_DO_NOT_MATCH__PLEASE_TRY_AGAIN_': 'Passwords do not match. Please try again.',
    '_123_PLEASE_CHOOSE_A_PICTURE_FOR_YOUR_PROFILE_': 'Please choose a picture for your profile.',
    '_928_PLEASE_WAIT_': 'Please wait...',
    '_117_SECURITY_GROUPS': 'Security Groups',
    '_706_SECURITY_QUESTION': 'Security Question',
    '_813_SECURITY_QUESTION_AND_ANSWER_CHANGE_FAILED_': 'Security question and answer change failed!',
    '_815_SECURITY_QUESTION_AND_ANSWER_CHANGE_SUCCESSFUL_': 'Security question and answer change successful!',
    '_838_SECURITY_QUESTION_MUST_BE_A_MINIMUM_OF__REQUIREDLENGTH__CHARACTERS_': 'Security question must be a minimum of {{requiredLength}} characters.',
    '_75_START_DATE': 'Start Date',
    '_659_SUBORDINATE': 'Subordinate',
    '_67_SUPERGROUP': 'SuperGroup',
    '_84_SYSTEM_ACCESS': 'System Access',
    '_85_SYSTEM_ID': 'System ID',
    '_663_SYSTEM_PARAMETER': 'System Parameter',
    '_87_SYSTEM_TYPE': 'System Type',
    '_953_THIS_WILL_TAKE_EFFECT_THE_NEXT_TIME_YOU_LOGIN_': 'This will take effect the next time you login.',
    '_812_UNABLE_TO_RETRIEVE_YOUR_CURRENT_SECURITY_QUESTION_': 'Unable to retrieve your current security question.',
    '_705_UPDATE': 'Update',
    '_118_USER_INFORMATION': 'User Information',
    '_119_USER_PROFILE': 'User Profile',
    '_72_USERNAME': 'Username',
    '_835_WELCOME_TO_COMPAS_': 'Welcome to Compas!',
    '_124_YOU_CAN_ONLY_UPLOAD_JPEG_FILES_': 'You can only upload JPEG files.',
    '_836_YOU_MUST_CHANGE_YOUR_PASSWORD_BEFORE_PROCEEDING__PLEASE_CREATE_A_NEW_PASSWORD_USING_THE_FORM_BELOW_': 'You must change your password before proceeding. Please create a new password using the form below.',
    '_811_YOUR_PASSWORD_HAS_CHANGED_': 'Your password has changed.',
    '_816_YOUR_SECURITY_QUESTION_AND_ANSWER_HAVE_BEEN_CHANGED_': 'Your security question and answer have been changed.',
    '_640__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_ENTER_A__FIELD_LABEL_': '{{field_label}} is a required field. Please enter a {{field_label}}.'
};
